import { EmploymentBoardDecisionLockViewModel } from '@fora-monorepo/employer-my-pages-common/types';

const hasLock: EmploymentBoardDecisionLockViewModel[] = [
  { validFromDate: '2023-11-01', validToDate: null, isLocked: true },
];

export const mockBoardDecisionLocks = {
  hasLock,
  noLock: [],
};
